<div [class.disabled]="disabled">
  <div class="content">
    <app-material-image class="image"
                        [padding]="true"
                        [src]="material.cover"
                        [type]="material.materialType"
                        [state]="material.localState"></app-material-image>
    <div class="bibliograpic-info">
      <div class="head">
        <span class="dk5">{{material.dk5}}</span>
        <app-material-image [type]="material.materialType"></app-material-image>
      </div>
      <div class="author truncate">{{material.author}}</div>
      <div class="title">{{material.title}}</div>
      <div class="faust truncate">
        {{material.faustNumber}}
        <span *ngIf="material.materialNumber"> / </span>
        <strong *ngIf="material.materialNumber">{{material.materialNumber}}</strong>
        <span *ngIf="material.numberOfPages"> - {{material.numberOfPages}}</span>
        <span *ngIf="material.periodicalInformation"> - {{material.periodicalInformation}}</span>
        <span *ngIf="material.publishedInYear"> - {{material.publishedInYear}}</span>
      </div>
      <div class="placement truncate">{{material.placementInfo}}</div>
    </div>
  </div>
  <div class="latest-action truncate">
    <strong>Seneste handling</strong>
    {{material.materialLogAction}} {{material.materialLogActionTime  | dateTimeOffSetPipe | cuiDateOrTimeToday}} af
    {{material.materialLogActionUser}}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/material/material/material.component.html